// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// RxJS
import { Observable, of } from 'rxjs';
// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../../_base/crud';

import { Global } from '../../../../shared/global';
// Models
import { WarehouseModel } from '../_models/warehouse.model';
import { mergeMap } from 'rxjs/operators';
import { ShareddataserviceService } from '../../../../shared/shareddataservice.service';

const API_CUSTOMERS_URL = Global.BASE_WAREHOUSE_ENDPOINT;
const API_URL = Global.BASE_WAREHOUSE_BY_COMPANYMID;

@Injectable()
export class WarehouseService {
	loggedCompanyMId: number;

	constructor(private http: HttpClient, private httpUtils: HttpUtilsService,
		private sharedService: ShareddataserviceService) { }

	getLoggedCompanyMId() {
		this.sharedService.companydata.subscribe(data => this.loggedCompanyMId = data[0]["CompanyMId"]);
	}

	// CREATE =>  POST: add a new warehouse to the server
	createWarehouse(warehouse: WarehouseModel): Observable<WarehouseModel> {
		// Note: Add headers if needed (tokens/bearer)
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<WarehouseModel>(API_CUSTOMERS_URL, warehouse, { headers: httpHeaders});
	}

	uploadImage(imageFile: File, imageName:any): Observable<any> {
		let formData = new FormData();
		formData.append('ImageFile', imageFile, imageFile.name);
		formData.append('imageName', imageName);

		const httpHeaders = new HttpHeaders();
		httpHeaders.set('Content-Type', 'multipart/form-data');

		const url = "Global.BASE_UPLOAD_CATEGORY_IMAGE_ENDPOINT";
		// Note: Add headers if needed (tokens/bearer)
		return this.http.post<any>(url, formData, { headers: httpHeaders });
	}

	// READ
	getAllWarehouses(): Observable<WarehouseModel[]> {
		this.getLoggedCompanyMId();
		const URL = API_URL + this.loggedCompanyMId;
		return this.http.get<WarehouseModel[]>(URL);
	}

	getWarehouseById(WarehouseId: number): Observable<WarehouseModel> {
		return this.http.get<WarehouseModel>(API_CUSTOMERS_URL + `/${WarehouseId}`);
	}

	// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
	// items => filtered/sorted result
	// Server should return filtered/sorted result
	findWarehouses(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		// Note: Add headers if needed (tokens/bearer)
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);

		this.getLoggedCompanyMId();
		const URL = API_URL + this.loggedCompanyMId;
		return this.http.get<QueryResultsModel[]>(URL).pipe(
            mergeMap(res => {
                const result = this.httpUtils.baseFilter(res, queryParams);
                return of(result);
            })
        );
	}

	// UPDATE => PUT: update the warehouse on the server
	updateWarehouse(WarehouseId: number, warehouse: WarehouseModel): Observable<any> {
		const httpHeader = this.httpUtils.getHTTPHeaders();
		return this.http.put(API_CUSTOMERS_URL + WarehouseId, warehouse, { headers: httpHeader });
	}

	// DELETE => delete the warehouse from the server
	deleteWarehouse(WarehouseId: number): Observable<WarehouseModel> {
		const url = `${API_CUSTOMERS_URL}${WarehouseId}`;
		return this.http.delete<WarehouseModel>(url);
	}
}
